module.exports = __webpack_public_path__ + "static/media/mosque-50.83370521.png";